export default "__VITE_ASSET__BAkAVdge__"